/**
 * Must load before `./App` so `UserManager` is not constructed on the HTTPS
 * redirect document (wrong localStorage). See main.tsx import order.
 */
import {
  redirectAndroidInAppHttpToHttpsIfNeeded,
  redirectCapacitorOAuthLoginBridgeIfNeeded,
  redirectCapacitorOAuthLogoutBridgeIfNeeded,
  shouldDeferReactBootstrapForNativeOAuthHandoff,
} from './lib/capacitorZitadelUrls';

if (typeof window !== 'undefined') {
  try {
    if (redirectAndroidInAppHttpToHttpsIfNeeded()) {
      // Navigation scheduled; do not run any other auth bootstrap logic.
    } else if (shouldDeferReactBootstrapForNativeOAuthHandoff()) {
      redirectCapacitorOAuthLoginBridgeIfNeeded() || redirectCapacitorOAuthLogoutBridgeIfNeeded();
    }
  } catch (e) {
    console.error('[ConnectGroove] native OAuth HTTPS handoff failed', e);
  }
}
